
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Labs</h1>
                </div>
            </div>
        </div>			
    </div>	
</section>
<section class="section-lg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="inner-title"  >
                    <h3>Computer Lab</h3>							
                   
                </div>
                <div class="text-justify" >
                    <blockquote>‘Computer themselves, and software yet to be developed, will revolutionize the way we learn’-Steve Jobs</blockquote>
                    <p>Innovation and technology have become a part and parcel of the day to day life today. At GHRCCST we make sure to provide you with amenities which are par excellence. Computer laboratory is a part of the same facility. Our state-of-the-art computer laboratory has a plethora of sections. And, each of it provides support to internet applications, design application and programming. Hence, you can be assured of being on the receiving end of knowledge with practical experience with us.</p>                    
                </div>
                <div class="inner-title"  >
                    <h3>Our attributes</h3>							
                   
                </div>
                <div class="text-justify" >
                    <ul class="list-item">
                        <li>Comprehensive assistance- Comprehensive assistance by the lab faculty and educators to assist you with any issues arising in the operation of equipment or software. They are well versed with their job and will be a helping hand as and when needed.</li>
                        <li> High Speed Internet- Our laboratory is coupled with high speed internet. You can be assured of seamless working with the same.</li>
                        <li>Latest Configuration- Our computers are associated with the latest configuration to aid you in better processing. This is not it. The software of the computer is upgraded from time to time. Thus, you will be able to take benefits of the latest with the laboratory.</li>
                        <li>Hands-on-Practical- We comprehend the need of hand-on-practical experience for our students. Hence, we have a good number of computers in our laboratory to suffice the need.</li>
                    </ul>                    
                    <p>Computer laboratory is for you to explore new depths of academic pursuits. Hence, utilize it with immense care. While technology never ceases to be the best friend, make sure you do not make it your enemy by misusing it. Do not let it be your worst nightmare.</p>
                </div>
            </div>
            <div class="col-md-4 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/lab-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/lab-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-4 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/lab-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/lab-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

